import { Html } from "@react-three/drei";
import Lottie from "lottie-react";
import animationData from "../../public/lottie/loader.json";
import "../Loader.css";

export default function Loader() {
  return (
    <Html fullscreen>
      <div className="carte">
        <Lottie animationData={animationData} loop={true} className="ship" />

        <p className="text">Our world is opening... just a moment.</p>
      </div>
    </Html>
  );
}
